export const awsBaseUrl = process.env.REACT_APP_AWS_BUCKET_BASE_URL;